export default {"src":"/_next/static/media/doctors-bag.e4f825ab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};